import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ensureBrowserSession } from '../_lib/browserSession';

const Home = () => {
  const history = useHistory();

  useEffect(() => {
    ensureBrowserSession().then((user) => {
      history.replace(user && ['Host', 'Both'].includes(user.type) ? '/properties' : '/login');
    });
  }, [history]);

  return (
    <div className="App">
      <div className="h-100 text-center">
        <img src="images/loading.gif" alt="" style={{ height: "200px" }} />
        <p>Please wait ...</p>
      </div>
    </div>
  );
}

export default Home;
